<template>
  <div class="container">
    <div class="goBackBtn" @click="$router.go(-1)">
      <h2>
        X
      </h2>
    </div>
    <div id="cookies-policy" class="cookies-policy" v-html="cookies"></div>
    <!-- OneTrust Cookies List start -->
    <div id="ot-sdk-cookie-policy" data-document-language="true"> </div>
    <!-- OneTrust Cookies List end -->
  </div>
</template>

<script>
import Axios from 'axios';
export default {
  name: "Cookies",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx"
    },
  },
  data(){
    return {
      cookies:'',  
    }
  },
  async mounted() {
    let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/cookies/aviso/V2')
    this.cookies = serviceResponse.data.replace('{', '').replace('"body":"', '').replace(`";
        }`,'')

      
    if (this.$route.path === '/cookies') {
      this.$nextTick(() => {
        setTimeout(() => {
          if (typeof Optanon !== 'undefined' && typeof Optanon.initializeCookiePolicyHtml === 'function') {
            Optanon.initializeCookiePolicyHtml();
          }
        }, 100);
      });
    }
  },
  watch: {
    '$route.path'(newPath) {
      if (newPath === '/cookies') {
        this.$nextTick(() => {
          setTimeout(() => {
            if (typeof Optanon !== 'undefined' && typeof Optanon.initializeCookiePolicyHtml === 'function') {
              Optanon.initializeCookiePolicyHtml();
            } else {
              console.warn('OneTrust not yet loaded or method missing');
            }
          }, 100);
        });
      }
    }
  },
};
</script>

<style lang="scss">
.container {
  padding-top: 0vw;
  @media screen and (max-width: 768px) {
    padding-top: 13vw;
  }
}
.goBackBtn {
  display: flex;
  flex-direction: row;
  width: 80px;
  background-color: transparent;
  border: none;
  font-family: 'DINRegular' !important;
  font-size: 1.4vw;
  float: right;
  position: absolute;
  top: 0px;
  right: 0px;
  color: #9E895C;
  h2 {
    margin-inline: 0;
  }
  @media screen and (max-width: 768px) {
    width: 42px;
    h2 {
      font-size: 4.8vw;
    }
  }
}
.goBackBtn:hover {
  cursor: pointer;
}
.cookies-policy {
    font-family: 'DINRegular' !important;
    font-size: 1.3vw !important;
    margin-right: 26.2pt !important;
    margin-left: 26.2pt !important;
    text-align: justify;
    padding-inline: 2vw;
    margin-top: 7vw !important;
    h3, p{
        //margin: 0;
        //margin-bottom: .5pt !important;
    }
    *{
        font-family: 'DINRegular' !important;
        font-size: 1.3vw !important;
        @media (max-width: 768px) {
            font-size: 4.9vw !important;
        }
    }
    // table {
    //     width: 100% !important;
    //     border-collapse: collapse !important;
    //     @media (max-width: 768px) {
    //         width: 0% !important;
    //     }
    // }
    // tr {
    //     font-size: 1.3vw !important;
    //     @media (max-width: 768px) {
    //         font-size: 3vw !important;
    //     }
    // }
    // th {
    //     border: solid 1px;
    //     font-size: 1.2vw !important;
    //     @media (max-width: 768px) {
    //         font-size: 2.9vw !important;
    //     }
    // }   
    // td {
    //     border: solid 1px;
    //     font-size: 1.2vw !important;
    //     @media (max-width: 768px) {
    //         font-size: 2.9vw !important;
    //     }
    // }
}
</style>